import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.SuccessMessageBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.CONFIRMATION_MESSAGE_CONTROL) {
    throw new Error('Expected a valid ConfirmationMessage control')
  }

  return {
    type: next.BLOCK_TYPE.SUCCESS_MESSAGE,
    required: false, // can never be required
    settings: {
      ...upCommonSettings(uischema),
      title: uischema.options?.title,
      text: uischema.options?.text,
      closeButtonText: uischema.options?.closeButtonText,
      // deprecated
      showCloseButton: Boolean(uischema.options?.showCloseButton)
    }
  }
}
